// Basically ensures that messages created before a listener are still recieved
angular.module('leanlaw').factory('messageBus', ['$q', function ($q) {
  let messages = [];
  let listeners = [];
  return {
    addMessage(messageId, allowDuplicates, payload) {
      if (!allowDuplicates) {
        if (messages.findIndex(m => m.id == messageId) != -1) return;
      }
      messages.push({
        id: messageId,
        payload
      });

      // Trigger listeners that are watching this message
      listeners.forEach(l => {
        if (l.trigger == messageId) {
          l.callback(payload);
        }
      });

      // Remove messages if there are listeners for this message
      if (listeners.filter(l => l.trigger == messageId).length) {
        messages = messages.filter(m => m.id != messageId);
      }
    },
    addListener(messageId, callback) {
      // Find messages relevant to this listener
      const m = messages.filter(m => m.id == messageId);

      // Trigger callback for each event
      if (m.length) {
        m.forEach(message => {
          callback(message.payload);
        });
      }
      listeners.push({
        trigger: messageId,
        callback
      });
    },
    removeListener(callback) {
      listeners = listeners.filter(l => l.callback != callback);
    }
  };
}]);